import { find } from 'lodash';
import { combineReducers } from 'redux';

import directors from './directors';
import photographers from './photographers';
import latest from './latest';
import media from './media';
import products from './products';
import screensavers from './screensavers';
import shop from './shop';
import collections from './collections';
import cart from './cart';

export default combineReducers({
  directors,
  photographers,
  media,
  latest,
  products,
  shop,
  screensavers,
  collections,
  cart,
});
